/** Product references define the public EK image path; descriptions and codes are not substituted. */
export function productImageUrl(reference) {
  if (typeof reference !== "string") return null;
  const name = reference.replace(/\s+/gu, "").replace(/\+/g, "PLUS");
  if (!name || name === "." || name === "..") return null;
  const segment = encodeURIComponent(name);
  return `https://www.ek.plus/wp-content/uploads/products/${segment}/images/${segment}.png`;
}
